import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/icon_hint.png'
import _imports_1 from '@/assets/image/icon/icon_offline.png'


const _withScopeId = n => (_pushScopeId("data-v-4cab35ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header flex-ter" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "goods-detail-content" }
const _hoisted_4 = { class: "goods-detail-item flex-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "goods-text" }
const _hoisted_7 = { class: "goods-info flex-ter" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_9 = { class: "flex-1" }
const _hoisted_10 = { class: "goods-price" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "goods-detail-item flex-center" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "goods-text" }
const _hoisted_15 = { class: "goods-info flex-ter" }
const _hoisted_16 = { class: "flex-1" }
const _hoisted_17 = { class: "goods-price" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "footer" }


import { t } from '@/plugins/i18n'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { showCurrentUnit } from '@/util/useYan'
import { sourceCountryRef, tCurrency } from '../country'
import { COUNTRY } from '@/global'


export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'goods', 'blackGoods'],
  emits: ['update:visible', 'close'],
  setup(__props, { emit: emits }) {

const props = __props



const cancel = () => {
  emits('update:visible', false)
  emits('close')
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(CommonDialog, {
    visible: __props.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    width: 500,
    onCancel: cancel,
    className: "no-stock-modal"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(_unref(t)('提示')), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.goods ?? [], (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "goods-detail",
            key: index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: item.productSkuImg,
                alt: "",
                class: "product-img"
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, _toDisplayString(item.productTitleJp), 1)
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.price) + " " + _toDisplayString(_unref(tCurrency)('元')), 1)
              ])
            ])
          ]))
        }), 128)),
        (__props.goods?.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "tip",
              innerHTML: _unref(t)('商品缺货，无法下单，请重新勾选商品下单。')
            }, null, 8, _hoisted_11))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.blackGoods ?? [], (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "goods-detail",
            key: index
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("img", {
                src: item.productSkuImg,
                alt: "",
                class: "product-img"
              }, null, 8, _hoisted_13),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(item.productTitleJp), 1)
                ]),
                _createElementVNode("div", _hoisted_17, _toDisplayString(item.price) + " " + _toDisplayString(_unref(tCurrency)('元')), 1)
              ])
            ])
          ]))
        }), 128)),
        (__props.blackGoods?.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "tip",
              innerHTML: _unref(t)('黑名单商品不支持下单')
            }, null, 8, _hoisted_18))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_el_button, {
            type: "primary",
            class: "footer-btn",
            onClick: cancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('我已知晓')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})